export default "__VITE_ASSET__CMD0WUry__"